import { createSelector } from 'reselect';

const selecNewQuestion = state => state.newQuestionPage;

export const selectNewQuestionPageState = createSelector(
    [selecNewQuestion],
    newQuestionPage => newQuestionPage.newQuestionHidden
);